import React from "react";
import { cn } from "@/lib/utils";

export function StatusPill({ children, variant = "default", className }) {
  const map = {
    default: "bg-[hsl(var(--surface-hover))] text-[hsl(var(--text-muted))]",
    primary: "bg-[hsl(var(--primary-muted))] text-[hsl(var(--primary))]",
    success: "bg-[hsl(var(--success-muted))] text-[hsl(var(--success))]",
    warning: "bg-[hsl(var(--warning-muted))] text-[hsl(var(--warning))]",
    danger: "bg-[hsl(var(--danger-muted))] text-[hsl(var(--danger))]",
  };
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-[11px] font-semibold tracking-wide", map[variant], className)}>
      {children}
    </span>
  );
}

export function leadStageVariant(stage) {
  if (stage === "Won") return "success";
  if (stage === "Lost") return "danger";
  if (stage === "Proposal") return "primary";
  if (stage === "Qualified") return "warning";
  return "default";
}

export function invoiceStatusVariant(s) {
  if (s === "paid") return "success";
  if (s === "overdue") return "danger";
  if (s === "pending") return "warning";
  return "default";
}

export function ticketStatusVariant(s) {
  if (s === "open") return "warning";
  if (s === "in_progress") return "primary";
  if (s === "resolved" || s === "closed") return "success";
  return "default";
}

export default StatusPill;
